<template>
  <dialog id="last_activity_detail_modal" class="modal">
    <div class="modal-box max-w-4xl">
      <form method="dialog">
        <button class="btn btn-sm btn-circle btn-ghost absolute top-2 right-2">
          ✕
        </button>
      </form>
      <h3 class="text-lg font-bold">Chi tiết hoạt động</h3>
      <div class="py-4">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <p><strong>Tên file:</strong> {{ activity?.file_name }}</p>
            <p><strong>Mô tả:</strong> {{ activity?.description }}</p>
            <p><strong>Đường dẫn:</strong> {{ activity?.full_path }}</p>
            <p><strong>Nguồn dữ liệu:</strong> {{ activity?.data_source }}</p>
          </div>
          <div>
            <p>
              <strong>Thời gian:</strong>
              {{
                activity?.action_time
                  ? dayjs(activity.action_time * 1000).format(
                      "DD/MM/YYYY HH:mm:ss",
                    )
                  : "Không xác định"
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import type { LastActivity } from "@/api/lastActivity";
import dayjs from "dayjs";
import { ref } from "vue";

const activity = ref<LastActivity | null>(null);

const openDialog = (selectedActivity: LastActivity) => {
  activity.value = selectedActivity;
  (
    document.getElementById("last_activity_detail_modal") as HTMLDialogElement
  ).showModal();
};

defineExpose({
  openDialog,
});
</script>
